import { useEffect } from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { makeStyles, tokens } from '@fluentui/react-components';
import Header from './components/Layout/Header';
import WeekView from './components/Calendar/WeekView';
import LoginPage from './components/Layout/LoginPage';
import { useAuth } from './hooks/useAuth';
import { setTokenGetter } from './services/api';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    backgroundColor: tokens.colorNeutralBackground2,
  },
  main: {
    flex: 1,
    overflow: 'auto',
    padding: tokens.spacingHorizontalL,
    '@media (max-width: 599px)': {
      padding: tokens.spacingHorizontalM,
      paddingTop: tokens.spacingVerticalM,
      paddingBottom: tokens.spacingVerticalXL,
    },
  },
});

function App() {
  const styles = useStyles();
  const { getAccessToken } = useAuth();

  // Set up API token getter
  useEffect(() => {
    setTokenGetter(getAccessToken);
  }, [getAccessToken]);

  return (
    <div className={styles.container}>
      <AuthenticatedTemplate>
        <Header />
        <main className={styles.main}>
          <WeekView />
        </main>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <LoginPage />
      </UnauthenticatedTemplate>
    </div>
  );
}

export default App;
